export default "__VITE_PUBLIC_ASSET__753c221b__"